import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { Placeholder, VisitorIdentification, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
// import { NavLink } from 'react-router-dom';
// import { withTranslation } from 'react-i18next';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { ScrollSmoother } from 'gsap-trial/ScrollSmoother';
// import { ScrollSmoother } from 'gsap/all';
import deepEqual from 'deep-equal';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import parse from 'html-react-parser';
import config from './temp/config';

// Using bootstrap is completely optional. It's used here to provide a clean layout for samples,
// without needing extra CSS in the sample app. Remove it in package.json as well if it's removed here.
import './assets/app.css';
import './assets/styles.css';
// import 'react-responsive-carousel/lib/styles/carousel.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-responsive-modal/styles.css';

// gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

// import logo from './assets/sc_logo.svg';

/*
  APP LAYOUT
  This is where the app's HTML structure and root placeholders should be defined.

  All routes share this root layout by default (this could be customized in RouteHandler),
  but components added to inner placeholders are route-specific.
*/

// This is boilerplate navigation for sample purposes. Most apps should throw this away and use their own navigation implementation.
// Most apps may also wish to use GraphQL for their navigation construction; this sample does not simply to support disconnected mode.
// let Navigation = ({ t, i18n }) => (
//   <div className="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-white border-bottom">
//     <h5 className="my-0 me-md-auto fw-normal">
//       <NavLink to="/" className="text-dark">
//         <img src={logo} alt="Sitecore" />
//       </NavLink>
//     </h5>
//     <nav className="my-2 my-md-0 me-md-3">
//       <a
//         className="p-2 text-dark"
//         href="https://jss.sitecore.com"
//         target="_blank"
//         rel="noopener noreferrer"
//       >
//         {t('Documentation')}
//       </a>
//       <NavLink to="/styleguide" className="p-2 text-dark">
//         {t('Styleguide')}
//       </NavLink>
//       <NavLink to="/graphql" className="p-2 text-dark">
//         {t('GraphQL')}
//       </NavLink>
//     </nav>
//   </div>
// );

// inject dictionary props (`t`) into navigation so we can translate it
// NOTE: using this is needed instead of using i18next directly to keep
// the component state updated when i18n state (e.g. current language) changes
// Navigation = withTranslation()(Navigation);

  const getOptimizedMetaDescription = (text) => {
  if (!text) return '';
  const charCount = text.length;

  // Rule 1: If ≤ 160 characters → use as-is
  if (charCount <= 160) return text;

  // Rule 2: If > 160 characters
  // Find the first full stop after 160 characters
  const firstFullStopAfter160 = text.indexOf('.', 160);

  // If found before 220 characters → cut there
  if (firstFullStopAfter160 !== -1 && firstFullStopAfter160 < 220) {
    return text.substring(0, firstFullStopAfter160 + 1);
  }

  // Rule 3: If not found, find the last full stop before 160 characters
  const lastFullStopBefore160 = text.lastIndexOf('.', 160);
  if (lastFullStopBefore160 !== -1) {
    return text.substring(0, lastFullStopBefore160 + 1);
  }

  // Rule 4: If no full stop exists, cut at the last word before 180 characters
  const truncatedAt180 = text.substring(0, 180);
  const lastSpaceBefore180 = truncatedAt180.lastIndexOf(' ');
  if (lastSpaceBefore180 !== -1) {
    return truncatedAt180.substring(0, lastSpaceBefore180) + '...';
  }

  return truncatedAt180 + '...';
};

const Layout = ({ route, context }) => {
  const _title = route.displayName.replace('-', ' ');
  const _result = _title?.replace(/([A-Z])/g, ' $1');
  const finalResult = _result?.charAt(0)?.toUpperCase() + _result?.slice(1);
  const ALT_TITLE = finalResult;

  const [url, setUrl] = useState();
  const [host, setHost] = useState('')
  const [schema, setSchema] = useState([])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setHost(window.location.host)
    }
  }, [])

  const location = useLocation();
  const [full_location, setFull_location] = useState('');
  const [path_name, setPath_name] = useState('');

    useEffect(() => {
    // Check if we're in the browser before using window
    if (typeof window !== 'undefined') {
      // Now it's safe to use the window object
      setUrl(window.location.href);
      const id = window.location.href.split('#')[1];
      setFull_location(`${window.location.protocol}//${window.location.host}`);
      setPath_name(window.location.pathname)
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView();
      }
    }

  }, []);

  // --- OPTIMIZED DESCRIPTION LOGIC ---
  const rawDescription = route?.fields?.MetaDescription?.value || ALT_TITLE;
  const optimizedDescription = getOptimizedMetaDescription(rawDescription);

  useEffect(() => {
    const initialSchemas = route?.fields?.SchemaType;
    const newSchemaArray = [];
    initialSchemas.forEach(initialSchema => {
      const headline = localStorage.getItem('headline')
      const currentSchema = initialSchema?.fields?.SchemaSyntax?.value || ''
      const newSchema = currentSchema
        ?.replaceAll('{{*CURRENTURL*}}', `${host}${location.pathname}`)
        ?.replaceAll('{{*MetaTitle*}}', route?.fields?.MetaTitle?.value)
        ?.replaceAll('{{*FeaturedImage*}}', route?.fields?.FeaturedImage?.value?.src || '')
        ?.replaceAll('{{*MetaDescription*}}', route?.fields?.MetaDescription?.value)
        ?.replaceAll('{{*Date*}}', route?.fields?.Date?.value?.split('T')[0])
        ?.replaceAll('{{*NEWSURL*}}', `${host}${location.pathname}`)
        ?.replaceAll('{{*Headline*}}', headline)
        ?.replaceAll('{{*DOMAINURL*}}', context?.siteSettings?.TargetHostName?.value)
        ?.replaceAll('{{*CreateDate*}}', context?.CreateDate)
        ?.replaceAll('{{*UpdatedDate*}}', context?.UpdatedDate)
        newSchemaArray.push(`{${newSchema}}`)
        setSchema(newSchemaArray)
      })
  }, [route, host])

  const [height, setHeight] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setHeight(ref.current.offsetHeight);
    };
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [ref]);

  // =========== OPEN THESE COMMENT WHEN PURCHASED MODULE ============
  // useLayoutEffect(() => {
  //   ScrollSmoother.create({
  //     smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
  //   });
  // }, []);
  // console.log('committed 12:50')
  // const headTagRaw = context?.siteSettings?.HeadTagManager?.value || '';
  // const headScriptMatch = headTagRaw.match(/<script[^>]*>([\s\S]*?)<\/script>/i);
  // const headScriptContent = headScriptMatch ? headScriptMatch[1] : '';


  return (
    <React.Fragment>
      {/* react-helmet enables setting <head> contents, like title and OG meta tags */}
      <Helmet>
        {/* <script type="text/javascript">{headScriptContent}</script> */}
        {/* {schema[0] && parse(schema[0])}
        {schema[1] && parse(schema[1])} */}
        {schema.map((item, index) => item && parse(item))}
        <title>{(route.fields && route.fields.Headline && route.fields.Headline.value) || `Sheikh Mohamed Bin Zayed Al Nahyan | ${ALT_TITLE}`}</title>
        <meta charset="utf-8" />
        <meta name="og:title" content={route.fields && route.fields?.MetaTitle?.value ? route.fields?.MetaTitle?.value : `Sheikh Mohamed Bin Zayed Al Nahyan | ${ALT_TITLE}`} />
        {/* --- UPDATED META DESCRIPTION TAGS --- */}
        <meta name="description" content={optimizedDescription} />
        <meta name="og:description" content={optimizedDescription} />
        <meta name="twitter:description" content={optimizedDescription} />
        <meta name="image" content={route?.fields?.FeaturedImage?.value?.src} />
        <meta name="og:image" content={route?.fields?.FeaturedImage?.value?.src} />
        <meta name="type" content={route?.fields?.SeoType?.value || 'Section'} />
        <meta name="keywords" content={route?.fields?.MetaKeywords?.value || ALT_TITLE} />
        <meta name="twitter:title" content={route?.fields?.MetaTitle?.value || ALT_TITLE} />
        <meta name="twitter:image" content={route?.fields?.FeaturedImage?.value?.src || ALT_TITLE} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="og:url" content={url} />
        {route?.fields?.NoFollow?.value && <meta name="robots" content="nofollow" />}
        {route?.fields?.NoIndex?.value && <meta name="robots" content="noindex" />}
        {context?.siteSettings?.googleMeta?.value && parse(context?.siteSettings?.googleMeta?.value)}
        {context?.ItemTwoLetterlanguages?.map((lang) => (
        <link key={`hreflang-${lang}`} rel="alternate" hrefLang={lang} href={`https://${context?.siteSettings?.TargetHostName?.value}/${lang}${context?.itemPath}`} />
        ))}
        {/* x-default pointing to English version */}
        <link rel="alternate" hrefLang="x-default" href={`https://${context?.siteSettings?.TargetHostName?.value}/en${context?.itemPath}`} />
        {/* {(!path_name.includes('/en/') && !path_name.includes('/ar')) ? <link rel="canonical" href={`${full_location}/ar${path_name}`} /> : <link rel="canonical" href={full_location + path_name} />}

        <link
          rel="canonical"
          href={`https://${context?.siteSettings?.TargetHostName?.value}/${context?.language}${context?.itemPath}`}
        /> */}
        <link
          rel="canonical"
          href={(path_name && !path_name.includes('/en') && !path_name.includes('/ar'))
           ? `https://${context?.siteSettings?.TargetHostName?.value}/ar${path_name}`
           : `https://${context?.siteSettings?.TargetHostName?.value}${path_name || ''}`
        }
        />

        {/* {Object.keys(schema).length > 0 && <script type="application/ld+json">{JSON.stringify(schema)}</script>} */}
        {/* (schema[0] && <script type="application/ld+json">{schema[0]}</script>)
        (schema[1] && <script type="application/ld+json">{schema[1]}</script>) */}
        {schema.map((item, index) => item && <script key={index} type="application/ld+json">{item}</script>)}
        {/* <script type="application/ld+json">{schema}</script> */}
      </Helmet>
      {/*
      VisitorIdentification is necessary for Sitecore Analytics to determine if the visitor is a robot.
      If Sitecore XP (with xConnect/xDB) is used, this is required or else analytics will not be collected for the JSS app.
      For XM (CMS-only) apps, this should be removed.

      VI detection only runs once for a given analytics ID, so this is not a recurring operation once cookies are established.
    */}
      <VisitorIdentification />
      {/* google analytics script */}
      {context?.siteSettings?.googleAnalyticsScript?.value && parse(context?.siteSettings?.googleAnalyticsScript?.value)}
      {/* <Navigation /> */}

      {/* root placeholder for the app, which we add components to using route data */}
      <div id="layout-container" dir={['ar'].includes(context?.language) ? 'rtl' : 'ltr'}>
        <header>
          <Placeholder name="jss-header" rendering={route} />
        </header>
        <main style={{ paddingBottom: height }}>
          <Placeholder name="jss-main" rendering={route} />
        </main>
        <footer ref={ref}>
          <Placeholder name="jss-footer" rendering={route} />
        </footer>
      </div>
    </React.Fragment>
  );
};

// We don't want to re-render `Layout` when route is changed but layout data is not loaded
// Layout will be re-rendered only when layout data is changed
const propsAreEqual = (prevProps, nextProps) => {
  if (deepEqual(prevProps.route, nextProps.route)) return true;

  return false;
};

export default React.memo(Layout, propsAreEqual);
